import { useLocation } from "react-router-dom";
import GeneratedObject from "../components/GeneratedObject";

const Home = () => {
  // Custom hook to parse query parameters
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const query = useQuery();
  const id = query.get("id"); // Get the 'id' from query parameters

  return (
    <GeneratedObject
      inputId={id} // Pass the id to GeneratedObject
      onError={(data) => {
        console.log(data);
      }}
      onSave={(data) => {
        console.log(data);
      }}
    />
  );
};

export default Home;
